module.exports = __webpack_public_path__ + "media/05.6e28e979.mp4";